import { createFileRoute } from '@tanstack/react-router';

// const Customers = React.lazy(
//   () => import('@/modules/backoffice/customers/pages/Customers'),
// );

export const Route = createFileRoute('/_authenticated/backoffice/customers/')({
  head: () => ({
    meta: [{ title: 'Clientes' }],
  }),
  component: () => <div />,
});
